import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

interface AddComponentDropdownProps {
  onAddTemplate: () => void;
  onAddGroup: () => void;
  onAddAsset: () => void;
  onAddTask?: () => void;
}

/**
 * Shared by the tree's detail header and the site-manager toolbar so both
 * offer the same creation flows.
 */
const AddComponentDropdown: React.FC<AddComponentDropdownProps> = ({
  onAddTemplate,
  onAddGroup,
  onAddAsset,
  onAddTask,
}) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown isOpen={isOpen} toggle={() => setIsOpen((prev) => !prev)}>
      <DropdownToggle color="primary" size="sm" caret>
        <i className="uil uil-plus mr-1" />
        {intl.formatMessage({ id: 'assets.actions.addComponent' })}
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem onClick={onAddTemplate}>
          <i className="uil uil-file-alt mr-2" />
          {intl.formatMessage({ id: 'assets.actions.newTemplate' })}
        </DropdownItem>
        <DropdownItem onClick={onAddGroup}>
          <i className="uil uil-folder mr-2" />
          {intl.formatMessage({ id: 'assets.actions.newGroup' })}
        </DropdownItem>
        <DropdownItem onClick={onAddAsset}>
          <i className="uil uil-box mr-2" />
          {intl.formatMessage({ id: 'assets.actions.newAsset' })}
        </DropdownItem>
        {onAddTask && (
          <DropdownItem onClick={onAddTask}>
            <i className="uil uil-clipboard-notes mr-2" />
            {intl.formatMessage({ id: 'assets.actions.newTask' })}
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default AddComponentDropdown;
